const musicLinksFR = {
    "view": {
        "table": {
            "title": "Votre liste de liens musicaux",
            "column": {
                "releaseName": "Nom de la sortie",
                "artists": "Artistes",
                "owner": "Propriétaire",
                "created": "Créé",
                "musicLink": "Lien musical",
                "action": "Action"
            },
            "button": {
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Recherche..."
            },
            "message": {
                "linkCopied": "Lien copié dans le presse-papiers !"
            }
        },
        "modal": {
            "edit": {
                "header": "Modifier {{musicLinkName}} ?",
                "body": "Êtes-vous sûr de vouloir modifier ce lien musical ?"
            },
            "delete": {
                "header": "Supprimer {{musicLinkName}} ?",
                "body": "Êtes-vous sûr de vouloir supprimer ce lien musical ?"
            }
        },
        "message": {
            "success": "Le lien musical a été supprimé !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "mlAllowanceSpent": "Vous avez dépensé votre allocation de liens musicaux. Pour créer plus de liens musicaux, veuillez mettre à niveau votre compte ou contacter notre équipe de support.",
            "subscriptionFeatureUnavailable": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "moduleAccessRestricted": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        }
    },
    "add": {
        "title": "Ajouter un lien musical",
        "form": {
            "label": {
                "source": "Source",
                "subUser": "Sous-utilisateur",
                "release": "Sortie",
                "artwork": "Illustration",
                "releaseName": "Nom de la sortie",
                "upcEan": "UPC/EAN",
                "artistName": "Nom de l'artiste",
                "urlPart1": "Partie URL 1",
                "urlPart2": "Partie URL 2",
                "musicLinkUrl": "Votre URL de lien musical est",
                "searchBy": "Rechercher par",
                "upcNumber": "Numéro UPC",
                "storeReleaseUrl": "URL de sortie du magasin",
                "colorCustomisation": "Personnalisation des couleurs",
                "premadeColors": "Couleurs prédéfinies",
                "customColors": "Couleurs personnalisées",
                "buttonStyle": "Style de bouton",
                "headerBackground": "Fond d'en-tête",
                "singleColor": "Couleur unique",
                "gradient": "Dégradé",
                "playerControlsColor": "Couleur des contrôles du lecteur",
                "titleColor": "Couleur du titre",
                "descriptionColor": "Couleur de la description",
                "buttonColor": "Couleur du bouton",
                "buttonHoverColor": "Couleur de survol du bouton",
                "buttonTextColor": "Couleur du texte du bouton"
            },
            "placeholder": {
                "subUser": "Sélectionner un sous-utilisateur...",
                "release": "Sélectionner une sortie",
                "releaseUpc": "Entrez le numéro UPC/EAN de la sortie, par ex. 5055964352523",
                "releaseStoreUrl": "Entrez l'URL de la sortie du magasin, par ex. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ou www.deezer.com/en/album/413370367",
                "urlPart1": "Sélectionner la partie URL 1"
            },
            "help_text": {
                "subUser": "Remarque : utilisez ce menu déroulant uniquement si vous souhaitez ajouter un lien musical pour l'un de vos sous-utilisateurs, sinon laissez non sélectionné.",
                "release": "Remarque : vous ne pouvez sélectionner que les sorties qui sont <strong>Distribuées.</strong>",
                "releaseUpc": "Remarque : utilisez ce menu déroulant uniquement si vous souhaitez ajouter une sortie déjà sur Spotify ou Deezer.",
                "releaseStoreUrl": "Remarque : utilisez ce menu déroulant uniquement si vous souhaitez ajouter une sortie déjà sur Spotify ou Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Sortie de lien musical existante",
                    "externalRelease": "Sortie externe"
                },
                "buttonStyle": {
                    "outlined": "Contour",
                    "filled": "Rempli"
                }
            },
            "button": {
                "reset": "Réinitialiser",
                "createNew": "Créer nouveau ?",
                "submit": "Soumettre"
            },
            "validation": {
                "formInvalid": "Le formulaire ne peut pas être soumis ! Veuillez remplir tous les champs et vérifier les erreurs !",
                "storeUrlRequired": "L'URL de {{store}} est requise",
                "storeUrlValid": "Veuillez ajouter une URL valide de {{store}}."
            }
        },
        "message": {
            "success": "Le lien musical a été ajouté !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "fetchingReleaseDetails": "Récupération des détails de la sortie..."
        }
    },
    "update": {
        "title": "Modifier le lien musical",
        "form": {
            "label": {
                "source": "Source",
                "release": "Sortie",
                "artwork": "Illustration",
                "releaseName": "Nom de la sortie",
                "upcEan": "UPC/EAN",
                "artistName": "Nom de l'artiste",
                "urlPart1": "Partie URL 1",
                "urlPart2": "Partie URL 2",
                "musicLinkUrl": "Votre URL de lien musical est",
                "searchBy": "Rechercher par",
                "upcNumber": "Numéro UPC",
                "storeReleaseUrl": "URL de sortie du magasin",
                "colorCustomisation": "Personnalisation des couleurs",
                "premadeColors": "Couleurs prédéfinies",
                "customColors": "Couleurs personnalisées",
                "buttonStyle": "Style de bouton",
                "headerBackground": "Fond d'en-tête",
                "singleColor": "Couleur unique",
                "gradient": "Dégradé",
                "playerControlsColor": "Couleur des contrôles du lecteur",
                "titleColor": "Couleur du titre",
                "descriptionColor": "Couleur de la description",
                "buttonColor": "Couleur du bouton",
                "buttonHoverColor": "Couleur de survol du bouton",
                "buttonTextColor": "Couleur du texte du bouton"
            },
            "placeholder": {
                "release": "Sélectionner une sortie",
                "releaseUpc": "Entrez le numéro UPC/EAN de la sortie, par ex. 5055964352523",
                "releaseStoreUrl": "Entrez l'URL de la sortie du magasin, par ex. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ou www.deezer.com/en/album/413370367",
                "urlPart1": "Sélectionner la partie URL 1"
            },
            "help_text": {
                "release": "Remarque : vous ne pouvez sélectionner que les sorties qui sont <strong>Distribuées.</strong>",
                "releaseUpc": "Remarque : utilisez ce menu déroulant uniquement si vous souhaitez ajouter une sortie déjà sur Spotify ou Deezer.",
                "releaseStoreUrl": "Remarque : utilisez ce menu déroulant uniquement si vous souhaitez ajouter une sortie déjà sur Spotify ou Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Sortie de lien musical existante",
                    "externalRelease": "Sortie externe"
                },
                "buttonStyle": {
                    "outlined": "Contour",
                    "filled": "Rempli"
                }
            },
            "button": {
                "reset": "Réinitialiser",
                "createNew": "Créer nouveau ?",
                "submit": "Soumettre"
            },
            "validation": {
                "formInvalid": "Le formulaire ne peut pas être soumis ! Veuillez remplir tous les champs et vérifier les erreurs !",
                "storeUrlRequired": "L'URL de {{store}} est requise",
                "storeUrlValid": "Veuillez ajouter une URL valide de {{store}}."
            }
        },
        "message": {
            "success": "Le lien musical a été mis à jour !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "fetchingReleaseDetails": "Récupération des détails de la sortie..."
        }
    },
    "storeLinksRow": {
        "title": "Liens de magasin",
        "label": {
            "store": "Magasin",
            "link": "Lien"
        },
        "button": {
            "remove": "Supprimer"
        },
        "model": {
            "addStore": {
                "header": "Ajouter un magasin",
                "body": "Veuillez choisir le magasin souhaité dans la liste ci-dessous :",
                "option": {
                    "mainStores": "Magasins principaux",
                    "otherStores": "Autres magasins"
                },
                "button": {
                    "add": "Ajouter un magasin",
                    "cancel": "Annuler"
                }
            }
        }
    },
    "previewFilesRow": {
        "title": "Aperçu des fichiers",
        "label": {
            "preview": "Aperçu",
            "artistName": "Nom de l'artiste",
            "trackName": "Nom du morceau"
        },
        "audioNotSupported": "Votre navigateur ne supporte pas l'élément audio."
    },
    "landingPagePreview": {
        "label": {
            "chooseMusicService": "Choisir un service de musique",
            "track": "Morceau",
            "artist": "Artiste",
            "time": "Temps",
            "others": "Autres"
        },
        "button": {
            "play": "Jouer"
        }
    },
    "viewStats": {
        "label": {
            "fetchingStats": "Récupération des statistiques pour le lien musical"
        },
        "topServices": {
            "title": "Meilleurs services",
            "subtitle": "CLIQUEZ PAR SERVICE",
            "table": {
                "column": {
                    "store": "Magasin",
                    "noOfVisits": "Nombre total de visites",
                    "noOfVisitsPct": "Pourcentage total de visites"
                },
                "label": {
                    "otherStores": "Autres magasins"
                }
            }
        },
        "topTracks": {
            "title": "Meilleurs morceaux",
            "subtitle": "CLIQUEZ PAR MORCEAU",
            "table": {
                "column": {
                    "trackName": "Nom du morceau",
                    "artistName": "Nom de l'artiste",
                    "noOfPlays": "Nombre de lectures",
                    "noOfPlaysPct": "Pourcentage de lectures"
                }
            }
        },
        "topTerritories": {
            "title": "Meilleurs territoires",
            "subtitle": "CLIQUEZ PAR TERRITOIRE",
            "table": {
                "column": {
                    "territory": "Territoire",
                    "noOfViews": "Nombre de vues",
                    "noOfViewsPct": "Pourcentage de vues"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Meilleurs types d'appareils",
            "subtitle": "CLIQUEZ PAR TYPE D'APPAREIL"
        },
        "topOperatingSystems": {
            "title": "Meilleurs systèmes d'exploitation",
            "subtitle": "CLIQUEZ PAR OS",
            "chart": {
                "label": {
                    "noOfViews": "Nombre de vues : ",
                    "operatingSystems": "Système d'exploitation"
                }
            }
        },
        "topBrowsers": {
            "title": "Meilleurs navigateurs",
            "subtitle": "CLIQUEZ PAR NAVIGATEUR",
            "table": {
                "column": {
                    "browser": "Navigateur",
                    "noOfViewsPct": "Pourcentage de vues (%)"
                }
            }
        }
    }
};

export default musicLinksFR;